<template>
  <div>
    <!-- Client Info -->
    <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-8">
                  <h4 class="card-title">{{ orgInfo().org_name }}</h4>
                  <p style="font-size: 1.3em;">Welcome {{ userInfo().name }}</p>
              </div>
          </div>
      </div>
    </div>
    <TestSearchWidget class="mt-3" />
    <RecentTestsWidget class="mt-3" />
  </div>
</template>

<script>
  import axios from 'axios'
  import TestSearchWidget from '../components/TestSearchWidget.vue'
  import RecentTestsWidget from '../components/RecentTestsWidget.vue'

  export default {
    name: 'Dashboard',
    components: {
      TestSearchWidget,
      RecentTestsWidget
    },
    methods: {      
      orgInfo() {
        return this.$authService.getUserAttachedOrg() || { }
      },
      userInfo() {
        return this.$authService.getUserInfo() ||  { }
      }
    }
  }
</script>
